import { api } from "..";

import { QueryProps } from "@/types/Api";
import { NewUser } from "@/types/ApiResponses/User";

export interface GetPlayerQueryParams {
  id: number;
}

export const getPlayer = async (
  props: QueryProps<GetPlayerQueryParams>
): Promise<NewUser> => {
  const res = await api.client.get(`/users-new/${props.params.id}`, {
    signal: props.signal,
  });
  return res.data;
};
